import canvas from '@classes/canvas'
import { isNumber } from 'lodash'

import { getUnitDx } from '../helper/canvasDraw'
import type { MainParams, StyleParams } from '../Meter'
import type { GaugeDrawResult } from './gauge_types'

export function drawMeccaGauge (
  meccaDistance: number = 0,
  meccaLocation: number = 0,
  mainParams: MainParams,
  styleParams: StyleParams
): GaugeDrawResult {
  const { prevValue, value, ctx, redraw, dpx, center, radius, unit, formatter, currentValue } = mainParams
  const { arcColor, color } = styleParams

  let newCurrentValue: number = currentValue

  const from = Number(prevValue)
  const to = Number(value)

  const drawing = (current: number) => {
    newCurrentValue = current
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    redraw(getUnitDx(current))

    const boatSize = { width: dpx * 1.5, height: radius + dpx * 12 }
    canvas.drawBoat(ctx, center - boatSize.width / 2, center - boatSize.height / 2, boatSize.width, boatSize.height)

    if (isNumber(meccaDistance)) {
      const distance = meccaDistance.toFixed()
      const value = distance ? ctx.measureText(distance.toString()) : ctx.measureText('0')
      canvas.drawValue(
        ctx,
        center - Number(value.width) / distance.toString().length - dpx,
        center + 5 * dpx,
        formatter(meccaDistance || 0),
        14 * dpx,
        color
      )

      if (unit) {
        canvas.drawUnit(ctx, center + Number(value.width) / 2 + 8 * dpx, center + 5 * dpx, unit, dpx * 9, color)
      }
    }

    canvas.drawArc(ctx, center, center, radius - dpx * 4, 0, Math.PI * 2, arcColor, dpx + 1)

    if (isNumber(meccaLocation)) {
      const start = canvas.xy(meccaLocation - current, center, radius - dpx * 5)
      const meccaSize = dpx * 3
      canvas.drawMecca(ctx, start.x - meccaSize / 2, start.y - meccaSize / 2, meccaSize)
    }
  }

  const animateId = canvas.animate(from, to, drawing, 2, 'mecca')

  return { animateId, newCurrentValue }
}
